export const environment = {
  supabaseUrl: 'https://oiskpvhsrxnnalvjwurb.supabase.co',
  supabaseAnonKey: ' sb_publishable_9iWNwyC1YIpe_T0jT32qSw_HKP3Aeds',
};
